<template>
  <div class="file-preview">
    <div class="images"  v-viewer="{ backdrop: 'static' }" style="display: none" @hidden="onHidden">
      <img v-for="(src, index) in images" :src="src" :key="index" ref="imagesWater" />
    </div>
    <base-dialog :visible.sync="visibleFile" show-close fullscreen>
      <template v-slot:header>{{ fileName }}</template>
      <iframe :src="viewUrl" class="fileContent"></iframe>
    </base-dialog>

  </div>
</template>

<script>
import { getFileType } from "@/utils/common"
import BaseDialog from "@/components/BaseComponents/Dialog"
import { url_prefix } from "@/utils/uploadFile"
import watermark from 'watermark-dom'

export default {
  name: "file-preview",
  components: { BaseDialog },
  props: {
    file: Object // { url: "", type: "", name: "",...}
  },
  data() {
    return {
      images: [],
      visibleFile: false,
      fileName: "",
      viewUrl: "",
      userInfo:"",
    }
  },
  mounted() {
    // getCurUser().then((res) => {
    //   this.userInfo=res.data.data.name+" "+res.data.data.telephone;
    // })

  },
  watch:{
    visibleFile(newVal,oldVal){
      if(newVal==true){
        watermark.init({ watermark_txt: this.userInfo ,watermark_width:200,watermark_alpha: 0.05})
      }else{
        watermark.init({ watermark_txt: " " })
      }
    },
  },
  methods: {
    getType: getFileType,
    onHidden() {
      watermark.init({ watermark_txt: " " })
    },
    preview(file, fileList = [],watermarks) {
      file = file || this.file
      // 当前展示图片的具体信息
      let url = file.url
      let type = file.type
      this.fileName = file.name
      this.userInfo=watermarks
      // console.log("watermark",watermarks)
      // 图片
      if (type === "img") {
        this.images = !this._.isEmpty(fileList)
          ? this.getImageList(fileList).map(image => image.url)
          : [url]
        let index = this._.indexOf(this.images, file.url)
        const viewer = this.$el.querySelector(".images").$viewer
        // 可以设置当前被点击图片显示
        viewer.view(index)
        viewer.show()

        watermark.init({ watermark_txt: this.userInfo,watermark_parent_node:"imagesWater",watermark_width:200,watermark_alpha: 0.05 })

      }
      // 文件
      if (["word", "excel", "ppt"].includes(type)) {
        this.viewUrl =
          "https://view.officeapps.live.com/op/embed.aspx?src=" +
          this.encodeName(url) +
          "&wdDownloadButton=False&wdInConfigurator=False&PowerPointView=SlideShowView"
        this.visibleFile = true
      }
      // pdf
      if (["pdf"].includes(file.type)) {
        this.viewUrl = url+"#toolbar=0"
        this.visibleFile = true
      }
    },
    getImageList(fileList) {
      return fileList
        .map(file => ({
          url: url_prefix + file.path,
          type: this.getType(file.type),
          name: file.name
        }))
        .filter(file => file.type === "img")
    },
    // 以前老数据路径里有特殊字符，这里处理一下
    encodeName(url) {
      let arr = url.split("/")
      arr[arr.length - 1] = encodeURIComponent(arr[arr.length - 1])
      return arr.join("/")
    },
  }
}
</script>

<style lang="scss" scoped>
.base-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
      height: 100%;
      .fileContent {
        border-width: 0;
        width: 100%;
        height: calc(100% - 4px);
      }
    }
  }
}
</style>

<style lang="scss">
.viewer-container {
  z-index: 9999 !important;
}
.watermark{
  //background-repeat: repeat;
  //background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.5' text-anchor='middle' dominant-baseline='middle' transform='rotate(-45, 100 100)'%3E这是水印%3C/text%3E%3C/svg%3E") repeat;
  //position: fixed;
  //top: 0;
  //left: 0;
  //width: 100%;
  //height: 100%;
  //pointer-events: none;z-index: 9999;
  //background: repeating-linear-gradient(
  //    45deg,
  //    transparent,
  //    transparent 20px,
  //);
  //background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.3) 25%, transparent 25%, transparent 75%, rgba(255, 255, 255, 0.3) 75%),
  //linear-gradient(-45deg, rgba(255, 255, 255, 0.3) 25%, transparent 25%, transparent 75%, rgba(255, 255, 255, 0.3) 75%);
  //background-size: 50px 50px;
  //background-position: 0 0;
  //
  //font-size: 24px;
  //font-weight: bold;
  //color: rgba(0, 0, 0, 0.3);
  //display: flex;
  //flex-wrap: wrap;
  //justify-content: space-around;
  //align-items: center;
  //z-index: 9998; /* 确保水印在内容下方 */
  //background-repeat: repeat;

  //position: fixed;
  //top: 0;
  //left: 0;
  //width: 100%;
  //height: 100%;
  //pointer-events: none; /* 避免干扰鼠标事件 */
  //z-index: 9999; /* 确保水印在内容下方 */
  //background-size: 200px 200px;
  //background-repeat: repeat;
  //background-attachment: fixed;
}
</style>
